import { render, staticRenderFns } from "./ModalMessageResponses.vue?vue&type=template&id=6e3d1a85&scoped=true"
import script from "./ModalMessageResponses.vue?vue&type=script&lang=js"
export * from "./ModalMessageResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d1a85",
  null
  
)

export default component.exports